// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"a17e66960d9c3684","5285":"07bd1fc89d1892fc"}[chunkId] + ".css";
};